import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { get } from 'lodash'
import { Table } from 'antd'

import { PortalLayout } from '../../components'
import LayoutImageBg from '../../../../assets/images/farmer-portal-reports.png'
import ReportIcon from '../../../../assets/images/productivity-report.png'
import { getMessage } from '../../../../util/IntlMessages'
import { api, request } from '../../../../util/handlerRequestUtil'

import './Styles.css'

const HIGH = 'Alta'
const MEDIUM = 'Média'
const LOW = 'Baixa'

const extractValues = {
  [HIGH]: (val) => [{ high: `${val.percents.toFixed(2)}%` }, { high: val.total }],
  [MEDIUM]: (val) => [{ medium: `${val.percents.toFixed(2)}%` }, { medium: val.total }],
  [LOW]: (val) => [{ low: `${val.percents.toFixed(2)}%` }, { low: val.total }]
}

const ProductiveEnvironment = ({ history, location }) => {
  const currentUser = useSelector((state) => state.auth.auth)
  const [report, setReport] = useState([])
  const [camps, setCamps] = useState(0)
  const [qttLocations, setQttLocations] = useState('0')
  const [maturationGroup, setMaturationGroup] = useState('')
  const [material, setMaterial] = useState('')

  useLayoutEffect(() => {
    if (!currentUser) {
      return history.push('/farmers/portal')
    }
  }, [])

  useEffect(() => {
    const { material, check, materialName, maturationGroup } = get(location, 'state')
    const city = JSON.parse(sessionStorage.getItem('selected_city')) || {}

    setMaturationGroup(maturationGroup)
    setMaterial(materialName)
    const { macroRegion, microRegion } = city

    fetchReport({ macroRegion, microRegion, materialsI2x: [material], materialsCheck: [check] })
  }, [])

  useEffect(() => {
    countLocations()
  }, [])

  async function countLocations() {
    const { count = 0 } = await request(api.countLocations())
    setQttLocations(new Intl.NumberFormat('pt-BR').format(count))
  }

  async function fetchReport(filters) {
    const { environmentProductive = [] } = await request(api.dashboardFarmerPortal(filters))

    if (environmentProductive.length === 0) return

    const values = environmentProductive.reduce(
      (acc, item) => {
        const [percent, total] = extractValues[item.environment_productive_planning](item)
        acc = { percents: { ...acc.percents, ...percent }, total: { ...acc.total, ...total } }
        return acc
      },
      { percents: {}, total: {} }
    )

    setReport([values.percents, values.total])

    const totalCamps = environmentProductive.reduce((acc, item) => acc + item.total, 0)
    setCamps(totalCamps)
  }

  const getColumns = () => [
    {
      title: getMessage('farmer.portal.high'),
      width: '189px',
      render: (item) => <p className="table-cell-text">{item.high}</p>
    },
    {
      title: getMessage('farmer.portal.medium'),
      width: '189px',
      render: (item) => <p className="table-cell-text">{item.medium}</p>
    },
    {
      title: getMessage('farmer.portal.low'),
      width: '189px',
      render: (item) => <p className="table-cell-text">{item.low}</p>
    }
  ]

  return (
    <PortalLayout
      bgImage={LayoutImageBg}
      centerImage={ReportIcon}
      title="Resultados do relatório"
      subtitle={getMessage('farmer.portal.productive.environment')}
      showAction
    >
      <div className="productive-environment">
        <div className="wrapper">
          <p className="title">{getMessage('farmer.portal.productive.environment')}</p>
          <p className="subtitle">
            Os dados informados são relacionados a safra 2021/2022 e de um total de {qttLocations} agricultores
          </p>

          <div className="box">
            <p className="bodyText">Material {material}</p>
          </div>

          <div className="box">
            <p className="bodyText">Grupo de Maturação {maturationGroup}</p>
          </div>

          <div className="box">
            <p className="bodyText">Número total de campos</p>
            <p className="bodyText2">{camps}</p>
          </div>

          <div className="table-wrapper">
            <p className="table-title">Materiais plantados na região</p>
            <Table
              key="a"
              columns={getColumns()}
              rowKey={(record) => `data_${record.high}`}
              pagination={false}
              scroll={{ x: true }}
              dataSource={report}
            />
          </div>
        </div>
      </div>
    </PortalLayout>
  )
}

export default ProductiveEnvironment
